import InvokerAddressSingleSelection from "src/components/ApproveAllowance/InvokerAddressSingleSelection";
import { useBatchApproveAllowancePreviewContext } from "src/views/AssetManagement/BatchApproveAllowance/contexts";

function InvokerAddressSelectionRow() {
  const {
    translate: t,
    invokerAddressDictionary,
    setInvokerAddressDictionary,
    submitParams,
    invokerAddressSelectionDependency: { isSecondLayerToken, isSmartAccount },
    walletMajorVersion,
    getIsInvokerAddressSelectionShow,
  } = useBatchApproveAllowancePreviewContext();

  if (!getIsInvokerAddressSelectionShow()) {
    return null;
  }

  const label = t("invoker_address");

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-end",
        gap: "1rem",
      }}>
      <div style={{ paddingBottom: "3px" }}>{label}</div>

      <InvokerAddressSingleSelection
        isSecondLayerToken={isSecondLayerToken}
        isSmartAccount={isSmartAccount}
        fieldName={label}
        chainId={submitParams.chainId}
        chainType={submitParams.chainType}
        currency={submitParams.assetName}
        value={
          invokerAddressDictionary[walletMajorVersion]?.invokerAddress ?? ""
        }
        tryDefaultWallet
        onChange={(address) => {
          setInvokerAddressDictionary((d) => ({
            ...d,
            [walletMajorVersion]: {
              invokerAddress: address,
            },
          }));
        }}
        walletMajorVersion={walletMajorVersion}
      />
    </div>
  );
}

export default InvokerAddressSelectionRow;
